// extracted by mini-css-extract-plugin
export default {"head":"styles_head__hGPYv"};